<ng-template #createProjectModalBox let-modal>
    <div class="modal-header">
        <h5 class="modal-title"> Create a New Project</h5>
        <button type="button" class="btn-sm btn-close btn-danger" (click)="modal.dismiss('Cross click')"></button>
    </div>

    <div class="modal-body">
        <form>
            <div class="mb-3">
                <label class="form-label fw-bold">Project Name<span class="text-danger"> * </span></label>
                <input type="text" class="form-control" [formControl]="nameControl"
                    [class.is-invalid]="isInvalid() || nameExists === true"
                    (input)="onNameInput($event)" placeholder="Enter project name">
                <div class="invalid-feedback" *ngIf="isInvalid() || nameExists === true">
                    <span *ngIf="hasError('required')">Project Name is required.</span>
                    <span *ngIf="hasError('maxlength')">Project Name must not exceed 20 characters.</span>
                    <span *ngIf="hasError('pattern')">Start with a letter; only letters, numbers, underscores.</span>
                    <span *ngIf="nameExists === true">Name already exists.</span>
                </div>
                <div class="form-text">Project Name must start with a letter. Valid characters are a-z, A-Z, 0-9, underscores (_).</div>
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <app-close-button (clicked)="modal.dismiss('Cross click')"></app-close-button>
        <app-upload-button [disabled]="nameControl.invalid" loadingText="'Creating...'" (clicked)="createProject()">
            Create
        </app-upload-button>
    </div>
</ng-template>